import React from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '../../store';
import AccountTable from '../../components/AccountTable/AccountTable';

const Debts: React.FC = () => {
  const { debts, rates } = useSelector((state: AppState) => ({
    debts: state.debts,
    rates: state.exchangeRates,
  }));

  return (
    <AccountTable
      items={debts}
      rates={rates}
      type="Debt"
      emptyMessage="You have no debts"
    />
  );
};

export default Debts;
